import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router } from "react-router-dom"
// styles
import "./index.css"
// redux
import { store } from "@redux/store.js"
import { Provider } from "react-redux"
import App from "./App"
// components

ReactDOM.createRoot(document.getElementById("root")!).render(
    <Provider store={store}>
        <React.StrictMode>
            <Router>
                <App />
            </Router>
        </React.StrictMode>
    </Provider>
)
